/* eslint-disable */
// Este arquivo não importa 'useTranslation' porque a função 't' será passada como parâmetro.

/**
 * Translates a KPI type key.
 * @param {function} t - The translation function from i18next.
 * @param {string} kpiType - The KPI type from the backend (e.g., "program").
 * @returns {string} The translated string.
 */
export const getKpiTypeTranslation = (t, kpiType) => {
  if (kpiType === "program") return t("kpi.type.program", "Program");
  if (kpiType === "initiative") return t("kpi.type.initiative", "Initiative");
  return kpiType || ""; // Fallback
};

/**
 * Translates a KPI subtype key.
 * @param {function} t - The translation function from i18next.
 * @param {string} kpiSubtype - The KPI subtype from the backend (e.g., "financial").
 * @returns {string} The translated string.
 */
export const getKpiSubtypeTranslation = (t, kpiSubtype) => {
  switch (kpiSubtype) {
    case "topo":
      return t("kpi.subtype.topo", "Topo");
    case "financial":
      return t("kpi.subtype.financial", "Financial");
    case "budget":
      return t("kpi.subtype.budget", "Budget");
    case "specific":
      return t("kpi.subtype.specific", "Specific");
    case "uncategorized":
      return t("kpi.subtype.uncategorized", "Uncategorized");
    default:
      return kpiSubtype || "";
  }
};
